import script from "./RecordDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./RecordDialog.vue?vue&type=script&setup=true&lang=js"

import "./RecordDialog.vue?vue&type=style&index=0&id=6d4aabae&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/campus-heating-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d4aabae"]])

export default __exports__